export default __webpack_public_path__ + "static/media/471.23f60f79.png";